import { useAppConfig } from 'application/configuration'
import { usePriceFormatter } from 'lib/use-price-formatter'
import { useMemo } from 'react'

import {
  CreditActiveProgram,
  CreditBehaviorByUser,
  TradeInBehaviourByUser,
  TradeInRate,
  TradeInValues
} from './detail/types'

type UseEditTradeInTextProps = {
  i18n: {
    tradeInEditDefault: string
  }
  state: {
    tradeIn: {
      behaviourByUser: TradeInBehaviourByUser
      rate: TradeInRate
      values: TradeInValues
    }
  } | null
}

export const useEditTradeInText = ({ state, i18n }: UseEditTradeInTextProps) => {
  const priceFormatter = usePriceFormatter()

  return useMemo(() => {
    if (!state) return ''

    const {
      tradeIn: { behaviourByUser, rate, values }
    } = state

    if (behaviourByUser === 'applied' || behaviourByUser === 'not_required') {
      if (rate.status === 'success_with_zero_price') return `${values.brand.name} ${values.model.name}`

      if (rate.status === 'success')
        return `${values.brand.name} ${values.model.name} - ${priceFormatter(rate.result.possibleCarPrice)}`
    }

    return i18n.tradeInEditDefault
  }, [priceFormatter, i18n.tradeInEditDefault, state])
}

type UseEditCreditTextProps = {
  i18n: {
    creditEditDefault: string
  }
  state: {
    credit: {
      behaviourByUser: CreditBehaviorByUser
      placeholder: number
      active_program: CreditActiveProgram
    }
  } | null
}

export const useEditCreditText = ({ state, i18n }: UseEditCreditTextProps) => {
  const priceFormatter = usePriceFormatter()
  const monthForms = useAppConfig().i18n.common.monthForms

  return useMemo(() => {
    if (!state) return ''

    const {
      credit: { behaviourByUser, placeholder, active_program }
    } = state

    if (behaviourByUser === 'none' || behaviourByUser === 'credit_in_progress') {
      if (placeholder === null) return i18n.creditEditDefault
      return `${priceFormatter(placeholder)}/${monthForms[0]}`
    }

    if (behaviourByUser === 'credit_applied' || behaviourByUser === 'cash_purchase') {
      return `${priceFormatter(active_program.payment)}/${monthForms[0]}`
    }

    return i18n.creditEditDefault
  }, [priceFormatter, i18n.creditEditDefault, monthForms, state])
}
